<template>
  <div class="main">
    <div class="editVersion div-layout">
      <div class="editVersion-main">
        <module-title title="版本信息">
          <div class="right">
            <el-button type="primary" size="medium" icon="el-icon-arrow-left" @click="$emit('back')">
              返回
            </el-button>
          </div>
        </module-title>
        <el-form
          ref="addApplicationForm"
          :model="addApplicationForm"
          :rules="handleRules"
          :validate-on-rule-change="false"
          label-position="right"
          label-width="150px"
        >
          <el-form-item label="软件包：" prop="packageUrl">
            <span v-if="handleType !== 'add'">{{ addApplicationForm.packageUrl }}</span>
            <upload-file
              :props="{
                serveCode: 'apk',
                accept: '.apk,.zip,.bin',
                progress:true,
                type: ['application/vnd.android.package-archive','application/x-zip-compressed','application/vnd.android.package-archive'],
                packageCheck:true
              }"
              @uploadSucess="uploadSucessFn"
              @fileUploading="fileUploadingFn"
              @apkParser="apkParserFn"
              @beforeUpload="beforeUploadFn"
            >
              <el-button
                :loading="fileUploading"
                size="small"
                type="primary"
                icon="el-icon-upload2"
                :disabled="handleType==='view'"
              >
                {{ fileUploading ? '上传文件中...' : '点击上传' }}
              </el-button>
              <el-tooltip placement="bottom" effect="light">
                <div slot="content">
                  应用包名统一规则<br>
                  一般：{应用名称}_{应用标识}_{当前版本号}_{当前迭代号}_{build号}_{环境参数} .zip/apk<br>
                  比如: 课桌先生_C01_2.0.0_2_202111081002_test.apk<br>
                  ROM：{应用名称}_{应用标识}_{基础迭代号}_{当前迭代号}_{build号}_{环境参数} .zip<br>
                  比如：技德V4_Q01_20201008_20211100_202111081003_release.zip<br>
                  环境参数定义：<br>
                  test  测试环境<br>
                  release 正式环境<br>
                  pre 预发布环境<br>
                  其中build号是时间，精确到分。迭代号统一做为版本校验，应用标识统一作为应用校验，<br>
                  迭代号、build号为数值类型，其它为字符类型。当前版本号、基础迭代号为0时，为全量升级。<br>
                </div>
                <i class="el-icon-question tips-icon" />
              </el-tooltip>
            </upload-file>
          </el-form-item>
          <el-form-item label="应用名称：" prop="campusAppName">
            {{ addApplicationForm.campusAppName }}
          </el-form-item>
          <el-form-item label="终端设备：" prop="terminalName">
            {{ addApplicationForm.terminalName }}
          </el-form-item>
          <el-form-item label="平台：" prop="platformTypeName">
            {{ addApplicationForm.platformTypeName }}
          </el-form-item>
          <el-form-item label="设备类型：" prop="deviceTypeName">
            {{ addApplicationForm.deviceTypeName }}
          </el-form-item>
          <el-form-item label="应用标识：" prop="code">
            {{ addApplicationForm.code }}
          </el-form-item>
          <el-form-item label="应用图标：" prop="logoUrl">
            <img v-show="addApplicationForm.logoUrl" :src="addApplicationForm.logoUrl" width="48" height="48">
          </el-form-item>
          <el-form-item label="应用简介：" prop="summary">
            {{ addApplicationForm.summary }}
          </el-form-item>
          <module-title title="版本信息" />
          <el-form-item label="MD5值：" prop="md5Value">
            {{ addApplicationForm.md5Value }}
          </el-form-item>
          <el-form-item label="包名：" prop="packageName">
            {{ addApplicationForm.packageName }}
          </el-form-item>
          <el-form-item label="迭代号：" prop="versionNumber">
            {{ addApplicationForm.upgradeWay===2? (addApplicationForm.baseIterationNumber||'')+'_'+ (addApplicationForm.iterationNumber||'') :addApplicationForm.iterationNumber }}
          </el-form-item>
          <el-form-item label="版本号：" prop="versionCode">
            <el-input
              v-model="addApplicationForm.versionCode"
              maxlength="10"
              name="versionCode"
              class="handle-form-input"
              :disabled="handleType!=='add'"
              @input="inputNum"
            />
            <el-tooltip placement="bottom" effect="light">
              <div slot="content">
                本次升级安装包的版本号，用来区分当<br>
                前版本与之前版本，不可随意填写，每<br>
                次升级的版本号由产品经理给出<br>
                <br>
              </div>
              <i class="el-icon-question tips-icon" />
            </el-tooltip>
          </el-form-item>
          <el-form-item label="版本描述：" prop="description">
            <el-input
              v-model="addApplicationForm.description"
              type="textarea"
              :rows="6"
              placeholder="请输入内容"
              class="handle-form-input"
              maxlength="1000"
              show-word-limit
              :disabled="handleType==='view'"
            />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="medium" @click="$emit('back')">
            取消
          </el-button>
          <el-button
            :loading="ajaxLoading"
            type="primary"
            size="medium"
            :disabled="handleType === 'view'"
            @click="handleAddUpgrade"
          >
            {{ ajaxLoading ? 'Loading' : '确定' }}
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  addVersion,
  updateVersion,
  getApplicationByCode,
  getVersionById,
  getAppVersionLatestList
} from '@/api/systemMaintenance/upgradeManage/versionManage';
import { getFileExtendingName } from '@/utils/index';
export default {
  name: 'EditVersion',
  props: {
    handleType: {
      type: String,
      default: 'add'
    },
    id: {
      type: String,
      default: ''
    },
    campusAppId: {
      type: String,
      default: ''
    },
    typeCode: {
      type: String,
      default: ''
    },
    terminalList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      handleRules: {
        versionCode: [{ required: true, message: '版本号不能为空', trigger: 'change' }],
        packageUrl: [{ required: true, message: '软件包不能为空', trigger: 'change' }]
      },
      allUpgradeWay: false,
      ajaxLoading: false,
      fileUploading: false,
      list: [],
      addApplicationForm: {},
      fileSuffix: ''// 文件后缀
    };
  },
  mounted() {
    if (this.id) this.init();
  },
  methods: {
    init() {
      getVersionById(this.id, { typeCode: this.typeCode })
        .then((result) => {
          const data = result.data.campusApp ? result.data.campusApp : {};
          delete result.data.campusApp;
          this.addApplicationForm = {
            ...result.data,
            campusAppName: data.name,
            terminalName: data.terminalTypeName,
            platformTypeName: data.platformTypeName,
            deviceTypeName: data.deviceTypeName,
            logoUrl: data.logoUrl,
            summary: data.summary,
            appId: data.appId,
            campusAppId: data.id,
            terminalTypeCode: data.terminalTypeCode,
            code: data.code,
            upgradeWay: data.upgradeWay

          };
          this.fileSuffix = this.addApplicationForm.packagePath.substring(this.addApplicationForm.packagePath.lastIndexOf('.')).toLowerCase();
          console.log(this.fileSuffix);
        })
        .catch((err) => {
          console.log(err);
          this.ajaxLoading = false;
        });
    },

    inputNum(val) {
      this.addApplicationForm.versionCode = val
        .replace(/[^a-zA-Z\d.]/g, '')
        .replace(/^[0.]{1,}/g, '');
    },
    uploadSucessImgFn(val) {
      this.addApplicationForm.logoPath = val.relativePath;
      this.addApplicationForm.logoUrl = val.absolutePath;
    },
    uploadSucessFn(val) {
      if (this.addApplicationForm.upgradeWay === 2) {
        this.$set(this.addApplicationForm, 'baseIterationNumber', Number(val.baseIterationNumber));
      } else {
        this.$set(this.addApplicationForm, 'baseIterationNumber', '');
      }
      this.$set(this.addApplicationForm, 'packageName', val.package ? val.package : '');
      this.$set(this.addApplicationForm, 'iterationNumber', Number(val.iterationNumber));
      this.$set(this.addApplicationForm, 'packagePath', val.relativePath);
      this.$set(this.addApplicationForm, 'packageUrl', val.absolutePath);
      this.$set(this.addApplicationForm, 'md5Value', val.md5Value);
      this.$set(this.addApplicationForm, 'fileSize', val.file.size);
      this.fileUploading = false;
    },

    fileUploadingFn(val) {
      this.fileUploading = val;
    },
    apkParserFn(val) {
      const ApkParser = require('app-info-parser/src/apk');
      const parser = new ApkParser(val.file);
      parser
        .parse()
        .then((result) => {
          console.log({ ...result, ...val });
          this.uploadSucessFn({ ...result, ...val });
          this.addApplicationForm.versionSecretKey = val.versionSecretKey;
        })
        .catch((err) => {
          console.log('err ----> ', err);
        });
    },
    // 新增编辑应用升级
    handleAddUpgrade() {
      this.$refs['addApplicationForm'].validate((valid) => {
        if (valid) {
          this.ajaxLoading = true;
          this.addApplicationForm.typeCode = this.typeCode;
          if (this.handleType === 'add') {
            addVersion(this.addApplicationForm)
              .then((result) => {
                this.$notify.success({
                  title: 'Success',
                  message: '添加成功',
                  showClose: false,
                  duration: 2000
                });
                this.ajaxLoading = false;
                this.$emit('back');
              })
              .catch((err) => {
                console.log(err);
                this.ajaxLoading = false;
              });
          } else {
            updateVersion(this.id, this.addApplicationForm)
              .then((result) => {
                this.$notify.success({
                  title: 'Success',
                  message: '编辑成功',
                  showClose: false,
                  duration: 2000
                });
                this.ajaxLoading = false;
                this.$emit('back');
              })
              .catch((err) => {
                console.log(err);
                this.ajaxLoading = false;
              });
          }
        } else {
          console.log('error submit!!');
          this.ajaxLoading = false;
          return false;
        }
      });
    },
    // 上传应用包名检查
    packageNameCheck(file) {
      var name = file.name.split('_');
      if (name.length !== 6) {
        return false;
      }
      const pattern = new RegExp(/^[\d\s\.*]+$/);
      if (!pattern.test(name[3]) || !pattern.test(name[4])) {
        return false;
      }
      return true;
    },
    // 上传应用包名检查 rom包时 校验基础迭代号是否为纯数字
    packageNameCheckRom(file, param) {
      var name = file.name.split('_');
      const pattern = new RegExp(/^[\d*]+$/);
      if (param.upgradeWay === 2 && !pattern.test(name[2])) {
        return false;
      }
      return true;
    },
    async beforeUploadFn(file, callback) {
      var msg = '';
      var name = file.name.split('_');
      var suffix = getFileExtendingName(file.name);
      var flag = this.packageNameCheck(file);
      if (!flag) return callback({ data: { flag: false, msg: '包名校验不正确，请重新上传!' }});

      if (suffix === '.apk') {
        const ApkParser = require('app-info-parser/src/apk');
        const parser = new ApkParser(file.raw);
        var params = await parser.parse();
        if (String(params.versionCode) !== name[3]) {
          return callback({ data: { flag: false, msg: '当前上传的包迭代号不正确，请重新上传！' }});
        }
      }
      if (this.handleType !== 'add') {
        const latestList = await getAppVersionLatestList({ typeCode: this.typeCode, campusAppId: this.campusAppId, pageNum: 1, pageSize: 1 });
        const latestListData = latestList.data.list && latestList.data.list.length === 1;
        if (latestListData && Number(name[3]) <= latestList.data.list[0].iterationNumber) {
          return callback({ data: { flag: false, msg: '当前上传的包迭代号小于等于最新迭代号，请重新上传！' }});
        }
      }
      if (this.handleType === 'add') { // 新增时查询
        const res = await getApplicationByCode({ typeCode: this.typeCode, code: name[1] });
        const data = res.data;
        if (!data) { return callback({ data: { flag: false, msg: '没有找到相应的应用，请重新上传!' }}); }
        var appInfo = {
          ...this.addApplicationForm,
          campusAppName: data.name,
          terminalName: data.terminalTypeName,
          platformTypeName: data.platformTypeName,
          deviceTypeName: data.deviceTypeName,
          logoUrl: data.logoUrl,
          summary: data.summary,
          appId: data.appId,
          campusAppId: data.id,
          terminalTypeCode: data.terminalTypeCode,
          code: data.code,
          upgradeWay: data.upgradeWay
        };
          // 判断包名校验规则
        if (data.upgradeWay === 2) flag = this.packageNameCheckRom(file, appInfo);
        if (!flag) { return callback({ data: { flag: false, msg: '包名校验不正确，请重新上传!' }}); }
        const latestList = await getAppVersionLatestList({ typeCode: this.typeCode, campusAppId: data.id, pageNum: 1, pageSize: 1 });
        const latestListData = latestList.data.list && latestList.data.list.length === 1;
        if (latestListData) {
          switch (latestList.data.list[0].campusApp.upgradeWay) {
            case 1:
              if (Number(name[3]) <= latestList.data.list[0].iterationNumber) {
                flag = false;
                msg = `迭代号低于之前版本，请重新上传！`;
              }
              break;
            case 2:
              if (Number(name[2]) > Number(name[3])) {
                flag = false;
                msg = `迭代号低于之前版本，请重新上传！`;
              }
              break;
          }
        }
        if (flag) this.addApplicationForm = appInfo;
      } else { // 编辑
        if (this.addApplicationForm.upgradeWay === 2) flag = this.packageNameCheckRom(file, this.addApplicationForm);
        if (!flag) {
          msg = '包名校验不正确，请重新上传!';
        } else if (name[1] !== this.addApplicationForm.code) {
          flag = false;
          msg = `应用标识不符合，请重新上传!`;
        }
      }
      return callback({ data: { flag, msg }});
    }
  }
};
</script>
<style lang="scss" scoped>
.editVersion {
  .el-date-editor.el-input {
    margin-left: 20px;
  }
  .handle-form-input {
    width: 300px;
  }
  .dialog-footer {
    padding: 20px;
    margin-left: 300px;
  }
}
</style>
